import dynamicSize from '@webtrader/core/dynamic-size';

export const ACTION_SHEET_IDS = {
  DEFAULT: 'DEFAULT_ACTION_SHEET',
  INDICATORS: {
    SERIES: 'CHART_INDICATORS_SERIES',
    PERIOD: 'CHART_INDICATORS_PERIOD'
  }
};

export const DEFAULT_BORDERED_INPUT_STYLES = {
  height: dynamicSize.convertSize(44),
  fontSize: dynamicSize.convertSize(15),
  paddingStart: dynamicSize.convertSize(10),
  paddingEnd: dynamicSize.convertSize(10),
  borderRadius: dynamicSize.convertSize(4),
  label: {
    fontSize: dynamicSize.convertSize(14),
    fontWeight: 500,
    paddingBottom: dynamicSize.convertSize(4)
  },
  number: {
    height: dynamicSize.convertSize(36),
    fontSize: dynamicSize.convertSize(14),
    fontWeight: 500,
    inlineTextFontSize: dynamicSize.convertSize(11)
  }
};

export const SMALL_BORDERED_INPUT_STYLES = {
  height: dynamicSize.convertSize(36),
  fontSize: dynamicSize.convertSize(13)
};

export const DEFAULT_TOUCH_ACTIVE_OPACITY = 0.7;

export const ACTION_SHEET_STYLES = {
  ACTION_BUTTON: {
    height: dynamicSize.convertSize(48),
    fontSize: dynamicSize.convertSize(16)
  }
};
